module.exports = __webpack_public_path__ + "static/laboheme10s-01ec8ec904305fc79c4fda15f3b0e6ab.jpg";